import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import './Form.module.css';

const Input = ({ onChange, value = '', type, hasError, ...props }) => {
  const [fieldValue, setFieldValue] = useState(value);

  const handleChange = event => {
    setFieldValue(event.target.value);

    if (onChange) {
      onChange(event);
    }
  };

  useEffect(
    () => {
      setFieldValue(value);
    },
    [value]
  );

  return (
    <input
      styleName={classNames('input', { hasError })}
      value={fieldValue}
      onChange={handleChange}
      type={type || 'text'}
      {...props}
    />
  );
};

export default Input;
